/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("hy", {
  Redo: "\u0540\u0561\u057b\u0578\u0580\u0564 \u0584\u0561\u0575\u056c",
  Undo: "\u0546\u0561\u056d\u0578\u0580\u0564 \u0584\u0561\u0575\u056c",
  Cut: "\u053f\u057f\u0580\u0565\u056c",
  Copy: "\u054a\u0561\u057f\u0573\u0565\u0576\u0565\u056c",
  Paste: "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c",
  "Select all": "\u0546\u0577\u0565\u056c \u0562\u0578\u056c\u0578\u0580\u0568",
  "New document":
    "\u0546\u0578\u0580 \u0583\u0561\u057d\u057f\u0561\u0569\u0578\u0582\u0572\u0569",
  Ok: "Ok",
  Cancel: "\u0553\u0561\u056f\u0565\u056c",
  "Visual aids":
    "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056c \u056f\u0578\u0576\u057f\u0578\u0582\u0580\u0576\u0565\u0580\u0568",
  Bold: "\u0539\u0561\u057e\u0561\u057f\u0561\u057c",
  Italic: "\u0547\u0565\u0572\u0561\u057f\u0561\u057c",
  Underline: "\u0538\u0576\u0564\u0563\u056e\u057e\u0561\u056e",
  Strikethrough: "\u0531\u0580\u057f\u0561\u0563\u056e\u057e\u0561\u056e",
  Superscript:
    "\u054e\u0565\u0580\u056b\u0576 \u056b\u0576\u0564\u0565\u0584\u057d",
  Subscript:
    "\u054d\u057f\u0578\u0580\u056b\u0576 \u056b\u0576\u0564\u0565\u0584\u057d",
  "Clear formatting":
    "\u0544\u0561\u0584\u0580\u0565\u056c \u0586\u0578\u0580\u0574\u0561\u057f\u0561\u057e\u0578\u0580\u0578\u0582\u0574\u0568",
  "Align left":
    "\u0541\u0561\u056d\u0561\u056f\u0578\u0572\u0574\u0575\u0561 \u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Align center":
    "\u053f\u0565\u0576\u057f\u0580\u0578\u0576\u0561\u056f\u0561\u0576 \u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Align right":
    "\u0531\u057b\u0561\u056f\u0578\u0572\u0574\u0575\u0561 \u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Justify:
    "\u0535\u0580\u056f\u056f\u0578\u0572\u0574\u0561\u0576\u056b \u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Bullet list":
    "\u0549\u0570\u0561\u0574\u0561\u0580\u0561\u056f\u0561\u056c\u057e\u0561\u056e \u0581\u0578\u0582\u0581\u0561\u056f",
  "Numbered list":
    "\u0540\u0561\u0574\u0561\u0580\u0561\u056f\u0561\u056c\u057e\u0561\u056e \u0581\u0578\u0582\u0581\u0561\u056f",
  "Decrease indent":
    "\u0553\u0578\u0584\u0580\u0561\u0581\u0576\u0565\u056c \u0571\u0561\u056d \u0565\u0566\u0580\u056b \u0570\u0565\u057c\u0561\u057e\u0578\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
  "Increase indent":
    "\u0544\u0565\u056e\u0561\u0581\u0576\u0565\u056c \u0571\u0561\u056d \u0565\u0566\u0580\u056b \u0570\u0565\u057c\u0561\u057e\u0578\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
  Close: "\u0553\u0561\u056f\u0565\u056c",
  Formats: "\u0556\u0578\u0580\u0574\u0561\u057f\u0576\u0565\u0580",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "\u0541\u0565\u0580 \u0562\u0580\u0561\u0578\u0582\u0566\u0565\u0580\u0568 \u0579\u056b \u0561\u057a\u0561\u0570\u0578\u057e\u0578\u0582\u0574 \u0561\u0576\u0574\u056b\u057b\u0561\u056f\u0561\u0576 \u0565\u056c\u0584 \u0583\u0578\u056d\u0561\u0576\u0561\u056f\u0574\u0561\u0576 \u0562\u0578\u0582\u0586\u0565\u0580\u056b\u0576\u0589 \u053d\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0585\u0563\u057f\u057e\u0565\u056c Ctrl+X/C/V \u057d\u057f\u0565\u0572\u0576\u0565\u0580\u056b\u0581\u0589",
  Headers: "\u054e\u0565\u0580\u0576\u0561\u0563\u0580\u0565\u0580",
  "Header 1": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 1",
  "Header 2": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 2",
  "Header 3": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 3",
  "Header 4": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 4",
  "Header 5": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 5",
  "Header 6": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 6",
  Headings: "\u054e\u0565\u0580\u0576\u0561\u0563\u0580\u0565\u0580",
  "Heading 1": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 1",
  "Heading 2": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 2",
  "Heading 3": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 3",
  "Heading 4": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 4",
  "Heading 5": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 5",
  "Heading 6": "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 6",
  Preformatted:
    "\u0546\u0561\u056d\u0561\u057a\u0565\u057d \u0571\u0565\u0582\u0561\u057e\u0578\u0580\u057e\u0561\u056e",
  Div: "Div",
  Pre: "Pre",
  Code: "\u053f\u0578\u0564",
  Paragraph:
    "\u054a\u0561\u0580\u0562\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Blockquote: "\u0544\u0565\u057b\u0562\u0565\u0580\u0578\u0582\u0574",
  Inline: "\u054f\u0578\u0572\u0561\u0575\u056b\u0576",
  Blocks: "\u0532\u056c\u0578\u056f\u0576\u0565\u0580",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "\u054f\u0565\u0584\u057d\u057f\u056b \u057f\u0565\u0572\u0561\u0564\u0580\u0578\u0582\u0574\u0568 \u056f\u0561\u057f\u0561\u0580\u057e\u0565\u056c\u0578\u0582 \u0567 \u0570\u0561\u057d\u0561\u0580\u0561\u056f \u057f\u0565\u0584\u057d\u057f\u056b \u057c\u0565\u056a\u056b\u0574\u0578\u057e\u0589 \u054a\u0561\u057f\u0573\u0565\u0576\u057e\u0561\u056e \u057f\u0565\u0584\u057d\u057f\u0568 \u057f\u0565\u0572\u0561\u0564\u0580\u057e\u0565\u056c\u0578\u0582 \u0567 \u0570\u0561\u057d\u0561\u0580\u0561\u056f \u057f\u0565\u0584\u057d\u057f\u056b \u0571\u0587\u0578\u057e \u0574\u056b\u0576\u0579\u0587 \u0561\u0575\u057d \u057c\u0565\u056a\u056b\u0574\u056b \u0561\u0576\u057b\u0561\u057f\u0578\u0582\u0574\u0568\u0589",
  Fonts: "\u0556\u0578\u0576\u057f\u0565\u0580",
  "Font Sizes": "\u054f\u0561\u057c\u056b \u0579\u0561\u0583",
  Class: "\u0534\u0561\u057d",
  "Browse for an image":
    "\u0538\u0576\u057f\u0580\u0565\u056c \u0576\u056f\u0561\u0580",
  OR: "\u053f\u0531\u0544",
  "Drop an image here":
    "\u0546\u056f\u0561\u0580\u0568 \u0563\u0581\u0565\u0584 \u0561\u0575\u057d\u057f\u0565\u0572",
  Upload: "\u054e\u0565\u0580\u0562\u0565\u057c\u0576\u0565\u056c",
  Block: "\u0532\u056c\u0578\u056f",
  Align:
    "\u0540\u0561\u057e\u0561\u057d\u0561\u0580\u0565\u0581\u0576\u0565\u056c",
  Default: "\u054d\u057f\u0561\u0576\u0564\u0561\u0580\u057f",
  Circle: "\u0547\u0580\u057b\u0561\u0576",
  Disc: "\u053f\u056c\u0578\u0580",
  Square: "\u0554\u0561\u057c\u0561\u056f\u0578\u0582\u057d\u056b",
  "Lower Alpha":
    "\u0553\u0578\u0584\u0580\u0561\u057f\u0561\u057c \u056c\u0561\u057f\u056b\u0576\u0561\u056f\u0561\u0576 \u057f\u0561\u057c\u0565\u0580",
  "Lower Greek":
    "\u0553\u0578\u0584\u0580\u0561\u057f\u0561\u057c \u0570\u0578\u0582\u0576\u0561\u056f\u0561\u0576 \u057f\u0561\u057c\u0565\u0580",
  "Lower Roman":
    "\u0553\u0578\u0584\u0580\u0561\u057f\u0561\u057c \u0570\u057c\u0578\u0574\u0565\u0561\u056f\u0561\u0576 \u0569\u057e\u0565\u0580",
  "Upper Alpha":
    "\u0544\u0565\u056e\u0561\u057f\u0561\u057c \u056c\u0561\u057f\u056b\u0576\u0565\u0580\u0565\u0576 \u057f\u0561\u057c\u0565\u0580",
  "Upper Roman":
    "\u0544\u0565\u056e\u0561\u057f\u0561\u057c \u0570\u057c\u0578\u0574\u0565\u0561\u056f\u0561\u0576 \u0569\u057e\u0565\u0580",
  "Anchor...": "\u053d\u0561\u0580\u056b\u057d\u056d...",
  Name: "\u0531\u0576\u0578\u0582\u0576",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id-\u0576 \u057a\u0565\u057f\u0584 \u0567 \u057d\u056f\u057d\u057e\u056b \u057f\u0561\u057c\u0578\u057e \u0587 \u056f\u0561\u0580\u0578\u0572 \u0567 \u057a\u0561\u0580\u0578\u0582\u0576\u0561\u056f\u0565\u056c \u057f\u0561\u057c\u0565\u0580, \u0569\u057e\u0565\u0580, \u0563\u056e\u056b\u056f, \u056f\u0565\u057f, \u057e\u0565\u0580\u057b\u0561\u056f\u0565\u0565\u057f \u056f\u0561\u0574 \u057f\u0578\u0572\u0561\u057f\u0561\u056f\u056b \u0563\u056e\u056b\u056f",
  "You have unsaved changes are you sure you want to navigate away?":
    "\u053f\u0561\u0576 \u0579\u057a\u0561\u0570\u057a\u0561\u0576\u057e\u0561\u056e \u0583\u0578\u0583\u0578\u056d\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0589 \u0534\u0578\u0582\u0584 \u056b\u0580\u0578\u055e\u0584 \u0578\u0582\u0566\u0578\u0582\u0574 \u0565\u0584 \u0564\u0578\u0582\u0580\u057d \u0563\u0561\u056c",
  "Restore last draft":
    "\u054e\u0565\u0580\u0561\u056f\u0561\u0576\u0563\u0576\u0565\u056c \u057e\u0565\u0580\u057b\u056b\u0576 \u0576\u0561\u056d\u0561\u0563\u056b\u056e\u0568",
  "Special character...":
    "\u0540\u0561\u057f\u0578\u0582\u056f \u057d\u056b\u0574\u057e\u0578\u056c\u0576\u0565\u0580...",
  "Source code":
    "\u053e\u0580\u0561\u0563\u0580\u0561\u0575\u056b\u0576 \u056f\u0578\u0564",
  "Insert/Edit code sample":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u056f\u0578\u0564\u0568",
  Language: "\u053c\u0565\u0566\u0578\u0582",
  "Code sample...": "\u053f\u0578\u0564\u056b \u0585\u0580\u0576\u0561\u056f",
  "Color Picker": "\u0533\u0578\u0582\u0576\u0561\u057a\u0576\u0561\u056f",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "\u0541\u0561\u056d\u056b\u0581 \u0561\u057b",
  "Right to left": "\u0531\u057b\u056b\u0581 \u0571\u0561\u056d",
  "Emoticons...":
    "\u054d\u0574\u0561\u0575\u056c\u056b\u056f\u0576\u0565\u0580...",
  "Metadata and Document Properties":
    "\u0553\u0561\u057d\u057f\u0561\u0569\u0572\u0569\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  Title: "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580",
  Keywords:
    "\u0548\u0580\u0578\u0576\u0578\u0572\u0561\u056f\u0561\u0576 \u0562\u0561\u057c\u0565\u0580",
  Description:
    "\u0546\u056f\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Robots: "Robots",
  Author: "\u0540\u0565\u0572\u056b\u0576\u0561\u056f",
  Encoding: "\u053f\u0578\u0564\u0561\u057e\u0578\u0580\u0578\u0582\u0574",
  Fullscreen:
    "\u0531\u0574\u0562\u0578\u0572\u057b \u0567\u056f\u0580\u0561\u0576\u0578\u057e",
  Action:
    "\u0533\u0578\u0580\u056e\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Shortcut: "\u053f\u0561\u0580\u0573\u0578\u0582\u0572\u056b",
  Help: "\u0555\u0563\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Address: "\u0540\u0561\u057d\u0581\u0565",
  "Focus to menubar": "Focus to menubar",
  "Focus to toolbar": "Focus to toolbar",
  "Focus to element path": "Focus to element path",
  "Focus to contextual toolbar": "Focus to contextual toolbar",
  "Insert link (if link plugin activated)":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0570\u0572\u0578\u0582\u0574 (\u0565\u0569\u0565 \u0570\u0572\u0578\u0582\u0574 \u0568\u0576\u0564\u056c\u0561\u0575\u0576\u0578\u0582\u0574\u0568 \u0561\u057e\u057f\u056b\u057e \u0567)",
  "Save (if save plugin activated)":
    "\u054a\u0561\u0570\u057a\u0561\u0576\u0565\u056c (\u0565\u0569\u0565 save \u0568\u0576\u0564\u056c\u0561\u0575\u0576\u0578\u0582\u0574\u0568 \u0561\u056f\u057f\u056b\u057e \u0567)",
  "Find (if searchreplace plugin activated)":
    "\u0553\u0576\u057f\u0580\u0565\u056c (\u0565\u0569\u0565 searchreplace \u0568\u0576\u0564\u056c\u0561\u0575\u0576\u0578\u0582\u0574\u0568 \u0561\u056f\u057f\u056b\u057e \u0567)",
  "Plugins installed ({0}):":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u057e\u0561\u056e \u0583\u056c\u0561\u0563\u056b\u0576\u0576\u0565\u0580 ({0}):",
  "Premium plugins:":
    "\u054e\u0573\u0561\u0580\u0578\u057e\u056b \u0568\u0576\u0564\u056c\u0561\u0575\u0576\u0578\u0582\u0574\u0576\u0565\u0580",
  "Learn more...":
    "\u053b\u0574\u0561\u0576\u0561\u056c \u0561\u057e\u0565\u056c\u056b\u0576 \u2024\u2024\u2024",
  "You are using {0}":
    "\u0534\u0578\u0582\u0584 \u0585\u0563\u057f\u0561\u0563\u0578\u0580\u056e\u0578\u0582\u0574 \u0565\u0584 {0}",
  Plugins:
    "\u0538\u0576\u0564\u056c\u0561\u0575\u0576\u0578\u0582\u0574\u0576\u0565\u0580",
  "Handy Shortcuts":
    "\u0555\u0563\u057f\u0561\u056f\u0561\u0580 \u056f\u0561\u0580\u0573\u0578\u0582\u0572\u056b\u0576\u0565\u0580",
  "Horizontal line":
    "\u0540\u0578\u0580\u056b\u0566\u0578\u0576\u0561\u056f\u0561\u0576 \u0563\u056b\u056e",
  "Insert/edit image":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u0576\u056f\u0561\u0580",
  "Image description":
    "\u0546\u056f\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Source: "\u0546\u056f\u0561\u0580\u056b \u0570\u0561\u057d\u0581\u0565",
  Dimensions: "\u0549\u0561\u0583\u0565\u0580",
  "Constrain proportions":
    "\u054a\u0561\u0570\u057a\u0561\u0576\u0565\u056c \u0574\u0561\u0577\u057f\u0561\u0562\u0561\u057e\u0578\u0580\u0578\u0582\u0574\u0568",
  General: "\u0533\u056c\u056d\u0561\u057e\u0578\u0580",
  Advanced: "\u053c\u0580\u0561\u0581\u0578\u0582\u0581\u056b\u0579",
  Style: "\u0548\u0573",
  "Vertical space":
    "\u0548\u0582\u0572\u0572\u0561\u0570\u0561\u0575\u0561\u0581 \u057f\u0561\u0580\u0561\u056e\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Horizontal space":
    "\u0540\u0578\u0580\u056b\u0566\u0578\u0576\u0561\u056f\u0561\u0576 \u057f\u0561\u0580\u0561\u056e\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Border: "\u0535\u0566\u0580\u0561\u0563\u056b\u056e",
  "Insert image":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0576\u056f\u0561\u0580",
  "Image...": "\u0546\u056f\u0561\u0580",
  "Image list": "Image list",
  "Rotate counterclockwise":
    "\u054a\u057f\u057f\u0565\u056c \u056a\u0561\u0574\u057d\u056c\u0561\u0584\u056b\u0576 \u0570\u0561\u056f\u0561\u057c\u0561\u056f",
  "Rotate clockwise":
    "\u054a\u057f\u057f\u0565\u056c \u056a\u0561\u0574\u057d\u056c\u0561\u0584\u056b \u0578\u0582\u0572\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562",
  "Flip vertically":
    "\u0548\u0582\u0572\u0572\u0561\u0570\u0561\u0575\u0561\u0581 \u0561\u0580\u057f\u0561\u0581\u0578\u056c\u0578\u0582\u0574",
  "Flip horizontally":
    "\u0540\u0578\u0580\u056b\u0566\u0578\u0576\u0561\u056f\u0561\u0576 \u0561\u0580\u057f\u0561\u0581\u0578\u056c\u0578\u0582\u0574",
  "Edit image":
    "\u053d\u0562\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u0576\u056f\u0561\u0580\u0568",
  "Image options":
    "\u0546\u056f\u0561\u0580\u056b \u056f\u0561\u0580\u0563\u0561\u057e\u0578\u0580\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
  "Zoom in": "\u0544\u0565\u056e\u0561\u0581\u0576\u0565\u056c",
  "Zoom out": "\u0553\u0578\u0584\u0580\u0561\u0581\u0576\u0565\u056c",
  Crop: "\u053f\u057f\u0580\u0565\u056c",
  Resize: "\u0553\u0578\u056d\u0565\u056c \u0579\u0561\u0583\u0568",
  Orientation:
    "\u053f\u0578\u0572\u0574\u0576\u0578\u0580\u0578\u0577\u0578\u0582\u0574",
  Brightness:
    "\u054a\u0561\u0575\u056e\u0561\u057c\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Sharpen: "Sharpen",
  Contrast: "\u053f\u0578\u0576\u057f\u0580\u0561\u057d\u057f",
  "Color levels": "Color levels",
  Gamma: "\u0533\u0561\u0574\u0574\u0561",
  Invert: "\u0553\u0578\u056d\u0561\u057f\u0565\u0572\u0565\u056c",
  Apply: "\u0540\u0561\u057d\u057f\u0561\u057f\u0565\u056c",
  Back: "\u0540\u0565\u057f",
  "Insert date/time":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0561\u0574\u057d\u0561\u0569\u056b\u057e/\u056a\u0561\u0574\u0561\u0576\u0561\u056f",
  "Date/time":
    "\u0531\u0574\u057d\u0561\u0569\u056b\u057e/\u056a\u0561\u0574\u0561\u0576\u0561\u056f",
  "Insert/Edit Link":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u0553\u0578\u0583\u0578\u056d\u0565\u056c \u0540\u0572\u0578\u0582\u0574\u0568",
  "Insert/edit link":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u0570\u0572\u0578\u0582\u0574",
  "Text to display":
    "\u0540\u0572\u0574\u0561\u0576 \u057f\u0565\u0584\u057d\u057f",
  Url: "Url",
  "Open link in...":
    "\u0532\u0561\u0581\u0565\u056c \u0570\u0572\u0578\u0582\u0574\u0568",
  "Current window":
    "\u0538\u0576\u0569\u0561\u0581\u056b\u056f \u057a\u0561\u057f\u0578\u0582\u0570\u0561\u0576\u0568",
  None: "\u0548\u0579\u056b\u0576\u0579",
  "New window":
    "\u0546\u0578\u0580 \u057a\u0561\u057f\u0578\u0582\u0570\u0561\u0576",
  "Remove link":
    "\u054b\u0576\u057b\u0565\u056c \u0570\u0572\u0578\u0582\u0574\u0568",
  Anchors: "\u053d\u0561\u0580\u056b\u057d\u056d\u0576\u0565\u0580",
  "Link...": "\u0540\u0572\u0578\u0582\u0574",
  "Paste or type a link":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u0584 \u056f\u0561\u0574 \u0563\u0580\u0565\u0584 \u0570\u0572\u0578\u0582\u0574\u0568",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "\u0544\u0578\u0582\u057f\u0584\u0561\u0563\u0580\u057e\u0561\u056e \u0570\u0572\u0578\u0582\u0574\u0568 \u056f\u0561\u0580\u056e\u0565\u057d \u0537\u056c. \u0583\u0578\u057d\u057f\u056b \u0570\u0561\u057d\u0581\u0565 \u0567: \u0534\u0578\u0582\u0584 \u056f\u0581\u0561\u0576\u056f\u0561\u0576\u0561\u0584 \u0561\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c mailto: \u0570\u0572\u0574\u0561\u0576 \u057d\u056f\u0566\u0562\u0578\u0582\u0574",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "\u0544\u0578\u0582\u057f\u0584\u0561\u0563\u0580\u057e\u0561\u056e \u0570\u0572\u0578\u0582\u0574\u0568 \u056f\u0561\u0580\u056e\u0565\u057d \u0561\u0580\u057f\u0561\u0584\u056b\u0576 \u0570\u0572\u0578\u0582\u0574 \u0567: \u0534\u0578\u0582\u0584 \u056f\u0581\u0561\u0576\u056f\u0561\u0576\u0561\u0584 \u0561\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c http:// \u0570\u0572\u0574\u0561\u0576 \u057d\u056f\u0566\u0562\u0578\u0582\u0574",
  "Link list":
    "\u0540\u0572\u0578\u0582\u0574\u0576\u0565\u0580\u056b \u0581\u0578\u0582\u0581\u0561\u056f",
  "Insert video":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u057e\u056b\u0564\u0565\u0578",
  "Insert/edit video":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u057e\u056b\u0564\u0565\u0578",
  "Insert/edit media":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u056c \u0574\u0565\u0564\u056b\u0561",
  "Alternative source":
    "\u0531\u0575\u056c\u0568\u0576\u057f\u0580\u0561\u0576\u0584\u0561\u0575\u056b\u0576 \u056f\u0578\u0564",
  "Alternative source URL":
    "\u0531\u0575\u056c\u0568\u0576\u057f\u0580\u0561\u0576\u0584\u0561\u0575\u056b\u0576 \u0561\u0572\u0562\u0575\u0578\u0582\u0580\u056b \u0570\u0572\u0578\u0582\u0574",
  "Media poster (Image URL)":
    "\u0544\u0565\u0564\u056b\u0561 \u057a\u0561\u057d\u057f\u0561\u057c (\u0546\u056f\u0561\u0580\u056b \u0570\u0572\u0578\u0582\u0574)",
  "Paste your embed code below:":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u0584 \u0541\u0565\u0580 \u056f\u0578\u0564\u0568 \u0561\u0575\u057d\u057f\u0565\u0572\u055d",
  Embed:
    "\u054f\u0565\u0572\u0561\u0564\u0580\u057e\u0578\u0572 \u056f\u0578\u0564",
  "Media...": "\u0544\u0565\u0564\u056b\u0561",
  "Nonbreaking space":
    "\u0531\u057c\u0561\u0576\u0581 \u0576\u0578\u0580 \u057f\u0578\u0572\u056b \u0562\u0561\u0581\u0561\u057f",
  "Page break":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0567\u057b\u056b \u0561\u0576\u057b\u0561\u057f\u056b\u0579",
  "Paste as text":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0578\u0580\u057a\u0565\u057d \u057f\u0565\u0584\u057d\u057f",
  Preview:
    "\u0546\u0561\u056d\u0576\u0561\u056f\u0561\u0576 \u0564\u056b\u057f\u0578\u0582\u0574",
  "Print...": "\u054f\u057a\u0565\u056c",
  Save: "\u054a\u0561\u0570\u057a\u0561\u0576\u0565\u056c",
  Find: "\u0553\u0576\u057f\u0580\u0565\u056c",
  "Replace with": "\u0553\u0578\u056d\u0561\u0580\u056b\u0576\u0565\u056c",
  Replace: "\u0553\u0578\u056d\u0561\u0580\u056b\u0576\u0565\u056c",
  "Replace all":
    "\u0553\u0578\u056d\u0561\u0580\u056b\u0576\u0565\u056c \u0562\u0578\u056c\u0578\u0580\u0568",
  Previous: "\u0546\u0561\u056d\u0578\u0580\u0564",
  Next: "\u0540\u0561\u057b\u0578\u0580\u0564",
  "Find and replace...":
    "\u0553\u0576\u057f\u0580\u0565\u056c \u0587 \u0583\u0578\u056d\u0561\u0580\u056b\u0576\u0565\u056c",
  "Could not find the specified string.":
    "\u0546\u0577\u057e\u0561\u056e \u057f\u0565\u0584\u057d\u057f\u0568 \u0579\u056b \u0563\u057f\u0576\u057e\u0565\u056c",
  "Match case":
    "\u0540\u0561\u0577\u057e\u056b \u0561\u057c\u0576\u0565\u056c \u057c\u0565\u0563\u056b\u057d\u057f\u0578\u0580\u0568",
  "Find whole words only":
    "\u0533\u057f\u0576\u0565\u056c \u0574\u056b\u0561\u0575\u0576 \u0561\u0574\u0562\u0578\u0572\u057b \u0562\u0561\u057c\u0565\u0580\u0568",
  "Spell check":
    "\u0548\u0582\u0572\u0572\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u057d\u057f\u0578\u0582\u0563\u0578\u0582\u0574",
  Ignore: "\u0531\u0576\u057f\u0565\u057d\u0565\u056c",
  "Ignore all":
    "\u0531\u0576\u057f\u0565\u057d\u0565\u056c \u0562\u0578\u056c\u0578\u0580\u0568",
  Finish: "\u0531\u057e\u0561\u0580\u057f\u0565\u056c",
  "Add to Dictionary":
    "\u0531\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c \u0562\u0561\u057c\u0561\u0580\u0561\u0576\u0578\u0582\u0574",
  "Insert table":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0561\u0572\u0575\u0578\u0582\u057d\u0561\u056f",
  "Table properties":
    "\u0531\u0572\u0575\u0578\u0582\u057d\u0561\u056f\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  "Delete table":
    "\u054b\u0576\u057b\u0565\u056c \u0561\u0572\u0575\u0578\u0582\u057d\u0561\u056f\u0568",
  Cell: "\u054e\u0561\u0576\u0564\u0561\u056f",
  Row: "\u054f\u0578\u0572",
  Column: "\u054d\u0575\u0578\u0582\u0576\u0575\u0561\u056f",
  "Cell properties":
    "\u054e\u0561\u0576\u0564\u0561\u056f\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  "Merge cells":
    "\u0544\u056b\u0561\u057e\u0578\u0580\u0565\u056c \u057e\u0561\u0576\u0564\u0561\u056f\u0576\u0565\u0580\u0568",
  "Split cell":
    "\u0532\u0561\u056a\u0561\u0576\u0565\u056c \u057e\u0561\u0576\u0564\u0561\u056f\u0568",
  "Insert row before":
    "\u0531\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c \u057f\u0578\u0572 \u057e\u0565\u0580\u0587\u0578\u0582\u0574",
  "Insert row after":
    "\u0531\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c \u057f\u0578\u0572 \u0576\u0565\u0580\u0584\u0587\u0578\u0582\u0574",
  "Delete row": "\u054b\u0576\u057b\u0565\u056c \u057f\u0578\u0572\u0568",
  "Row properties":
    "\u054f\u0578\u0572\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  "Cut row": "\u053f\u057f\u0580\u0565\u056c \u057f\u0578\u0572\u0568",
  "Copy row":
    "\u054a\u0561\u057f\u0573\u0565\u0576\u0565\u056c \u057f\u0578\u0572\u0568",
  "Paste row before":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u057f\u0578\u0572\u0568 \u057e\u0565\u0580\u0587\u0578\u0582\u0574",
  "Paste row after":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u057f\u0578\u0572\u0568 \u0576\u0565\u0580\u0584\u0587\u0578\u0582\u0574",
  "Insert column before":
    "\u0531\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c \u0576\u0578\u0580 \u057d\u0575\u0578\u0582\u0576 \u0571\u0561\u056d\u056b\u0581",
  "Insert column after":
    "\u0531\u057e\u0565\u056c\u0561\u0581\u0576\u0565\u056c \u0576\u0578\u0580 \u057d\u0575\u0578\u0582\u0576 \u0561\u057b\u056b\u0581",
  "Delete column":
    "\u0541\u0576\u057b\u0565\u056c \u057d\u0575\u0578\u0582\u0576\u0568",
  Cols: "\u054d\u0575\u0578\u0582\u0576\u0575\u0561\u056f\u0576\u0565\u0580",
  Rows: "\u054f\u0578\u0572\u0565\u0580",
  Width: "\u053c\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Height:
    "\u0532\u0561\u0580\u0571\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Cell spacing":
    "\u0531\u0580\u057f\u0561\u0584\u056b\u0576 \u057f\u0561\u0580\u0561\u056e\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Cell padding":
    "\u0546\u0565\u0580\u0584\u056b\u0576 \u057f\u0561\u0580\u0561\u056e\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Show caption":
    "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056c \u057e\u0565\u0580\u0576\u0561\u0563\u056b\u0580\u0568",
  Left: "\u0541\u0561\u056d",
  Center: "\u053f\u0565\u0576\u057f\u0580\u0578\u0576",
  Right: "\u0531\u057b",
  "Cell type": "\u054e\u0561\u0576\u0564\u0561\u056f\u056b \u057f\u056b\u057a",
  Scope: "Scope",
  Alignment:
    "\u0540\u0561\u057e\u0561\u057d\u0561\u0580\u0565\u0581\u0578\u0582\u0574",
  "H Align":
    "\u0540. \u0540\u0561\u057e\u0561\u057d\u0561\u0580\u0565\u0581\u0578\u0582\u0574",
  "V Align":
    "\u0548\u0582. \u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0565\u0581\u0578\u0582\u0574",
  Top: "\u054e\u0565\u0580\u0587",
  Middle: "\u0544\u0565\u057b\u057f\u0565\u0572",
  Bottom: "\u0546\u0565\u0580\u0584\u0587",
  "Header cell":
    "\u054e\u0565\u0580\u0576\u0561\u0563\u0580\u056b \u057e\u0561\u0576\u0564\u0561\u056f\u0576\u0565\u0580",
  "Row group":
    "\u054f\u0578\u0572\u0565\u0580\u056b \u056d\u0578\u0582\u0574\u0562",
  "Column group":
    "\u054d\u0575\u0578\u0582\u0576\u0575\u0561\u056f\u0576\u0565\u0580\u056b \u056d\u0578\u0582\u0574\u0562",
  "Row type": "\u054f\u0578\u0572\u056b \u057f\u056b\u057a",
  Header: "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580",
  Body:
    "\u054a\u0561\u0580\u0578\u0582\u0576\u0561\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Footer:
    "\u0531\u0572\u0575\u0578\u0582\u057d\u0561\u056f\u056b \u057d\u057f\u0578\u0580\u056b\u0576 \u0570\u0561\u057f\u057e\u0561\u056e",
  "Border color": "\u0535\u0566\u0580\u0561\u0563\u056b\u056e",
  "Insert template...":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u0584 \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
  Templates:
    "\u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0576\u0565\u0580",
  Template: "\u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
  "Text color": "\u054f\u0561\u057c\u056b \u0563\u0578\u0582\u0575\u0576",
  "Background color": "\u0556\u0578\u0576\u056b \u0563\u0578\u0582\u0575\u0576",
  "Custom...": "\u0531\u0575\u056c...",
  "Custom color": "\u0531\u0575\u056c \u0563\u0578\u0582\u0575\u0576",
  "No color": "\u0531\u0576\u0563\u0578\u0582\u0575\u0576",
  "Remove color":
    "\u054b\u0576\u057b\u0565\u056c \u0563\u0578\u0582\u0575\u0576\u0568",
  "Table of Contents": "\u0551\u0561\u0576\u056f",
  "Show blocks":
    "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056c \u0562\u056c\u0578\u056f\u0576\u0565\u0580\u0568",
  "Show invisible characters":
    "\u0551\u0578\u0582\u0575\u0581 \u057f\u0561\u056c \u0561\u0576\u057f\u0565\u057d\u0561\u0576\u0565\u056c\u056b \u057d\u056b\u0574\u057e\u0578\u056c\u0576\u0565\u0580\u0568",
  "Word count": "\u0532\u0561\u057c\u056b \u0584\u0561\u0576\u0561\u056f",
  Count: "\u0554\u0561\u0576\u0561\u056f\u0568",
  Document: "\u0553\u0561\u057d\u057f\u0561\u0569\u0578\u0582\u0572\u0569",
  Selection:
    "\u0538\u0576\u057f\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Words: "\u0532\u0561\u057c\u0565\u0580",
  "Words: {0}":
    "\u0532\u0561\u057c\u0565\u0580\u056b \u0584\u0561\u0576\u0561\u056f: {0}",
  "{0} words": "{0} \u0562\u0561\u057c",
  File: "\u0556\u0561\u0575\u056c",
  Edit: "\u053d\u0574\u0562\u0561\u0563\u0580\u0565\u056c",
  Insert: "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c",
  View: "\u054f\u0565\u057d\u0584",
  Format: "\u0556\u0578\u0580\u0574\u0561\u057f",
  Table: "\u0531\u0572\u0575\u0578\u0582\u057d\u0561\u056f",
  Tools: "\u0533\u0578\u0580\u056e\u056b\u0584\u0576\u0565\u0580",
  "Powered by {0}": "Powered by {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "\u054f\u0565\u0584\u057d\u057f\u0561\u0575\u056b\u0576 \u0564\u0561\u0577\u057f\u0589 \u054d\u0565\u0572\u0574\u0565\u0584 ALT-F9 \u0574\u0565\u0576\u0575\u0578\u0582\u056b \u0570\u0561\u0574\u0561\u0580\u0589 ALT-F10 \u0563\u0578\u0580\u056e\u056b\u0584\u0576\u0565\u0580\u056b \u057e\u0561\u0570\u0561\u0576\u0561\u056f\u0589 \u054d\u0565\u0572\u0574\u0565\u0584 ALT-0 \u0585\u0563\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0561\u0574\u0561\u0580",
  "Image title":
    "\u0546\u056f\u0561\u0580\u056b \u057e\u0565\u0580\u0576\u0561\u0563\u056b\u0580",
  "Border width":
    "\u054d\u0561\u0570\u0574\u0561\u0576\u056b \u056c\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
  "Border style":
    "\u054d\u0561\u0570\u0574\u0561\u0576\u056b \u0578\u0573\u0568",
  Error: "\u054d\u056d\u0561\u056c",
  Warn: "\u0536\u0563\u0578\u0582\u0577\u0561\u0581\u0578\u0582\u0574",
  Valid: "\u054e\u0561\u057e\u0565\u0580 \u0567",
  "To open the popup, press Shift+Enter":
    "\u0539\u057c\u0578\u0582\u0581\u056b\u056f\u0568 \u0562\u0561\u0581\u0565\u056c\u0578\u0582 \u0570\u0561\u0574\u0561\u0580 \u057d\u0565\u0572\u0574\u0565\u0584 Shift + Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "\u0540\u0561\u0580\u0578\u0582\u057d\u057f \u057f\u0565\u0584\u057d\u057f\u0561\u0575\u056b\u0576 \u057f\u0561\u0580\u0561\u056e\u0584: \u0555\u0563\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0561\u0574\u0561\u0580 \u057d\u0565\u0572\u0574\u0565\u0584 ALT-0:",
  "System Font":
    "\u0540\u0561\u0574\u0561\u056f\u0561\u0580\u0563\u056b \u057f\u0561\u057c\u0561\u057f\u0565\u057d\u0561\u056f",
  "Failed to upload image: {0}":
    "\u0549\u0570\u0561\u057b\u0578\u0572\u057e\u0565\u0581 \u057e\u0565\u0580\u0562\u0565\u057c\u0576\u0565\u056c \u057a\u0561\u057f\u056f\u0565\u0580\u0568: {0}",
  "Failed to load plugin: {0} from url {1}":
    "\u0549\u0570\u0561\u057b\u0578\u0572\u057e\u0565\u0581 \u0562\u0565\u057c\u0576\u0565\u056c \u057a\u056c\u0561\u0563\u056b\u0576\u0568\u0589 {0} \u0570\u0572\u0578\u0582\u0574\u056b\u0581 {1}",
  "Failed to load plugin url: {0}":
    "\u0549\u0570\u0561\u057b\u0578\u0572\u057e\u0565\u0581 \u0562\u0565\u057c\u0576\u0565\u056c \u057a\u056c\u0561\u0563\u056b\u0576\u0568 \u0570\u0572\u0578\u0582\u0574\u056b\u0581\u0589 {0}",
  "Failed to initialize plugin: {0}":
    "\u0549\u0570\u0561\u057b\u0578\u0572\u057e\u0565\u0581 \u0574\u056b\u0561\u0581\u0576\u0565\u056c \u057a\u056c\u0561\u0563\u056b\u0576\u0568\u0589 {0}",
  example: "\u0585\u0580\u056b\u0576\u0561\u056f",
  Search: "\u0553\u0576\u057f\u0580\u0565\u056c",
  All: "\u0532\u0578\u056c\u0578\u0580\u0568",
  Currency: "\u0531\u0580\u056a\u0578\u0582\u0575\u0569",
  Text: "\u054f\u0565\u0584\u057d\u057f",
  Quotations:
    "\u0544\u0565\u057b\u0562\u0565\u0580\u0578\u0582\u0574\u0576\u0565\u0580",
  Mathematical:
    "\u0544\u0561\u0569\u0565\u0574\u0561\u057f\u056b\u056f\u0561\u056f\u0561\u0576",
  "Extended Latin":
    "\u0538\u0576\u0564\u0561\u0580\u0571\u0561\u056f \u056c\u0561\u057f\u056b\u0576\u0565\u0580\u0565\u0576",
  Symbols: "\u054d\u056b\u0574\u057e\u0578\u056c\u0576\u0565\u0580",
  Arrows: "\u054d\u056c\u0561\u0584\u0576\u0565\u0580",
  "User Defined":
    "\u0555\u0563\u057f\u0561\u0563\u0578\u0580\u056e\u0578\u0572\u056b \u056f\u0578\u0572\u0574\u056b\u0581 \u054d\u0561\u0570\u0574\u0561\u0576\u057e\u0561\u056e",
  "dollar sign":
    "\u0564\u0578\u056c\u056c\u0561\u0580\u056b \u0576\u0577\u0561\u0576",
  "currency sign":
    "\u0561\u0580\u056a\u0578\u0582\u0575\u0569\u056b \u0576\u0577\u0561\u0576",
  "euro-currency sign":
    "\u0565\u057e\u0580\u0578-\u0561\u0580\u056a\u0578\u0582\u0575\u0569\u056b \u0576\u0577\u0561\u0576",
  "colon sign":
    "\u056f\u0580\u056f\u0576\u0561\u056f\u0565\u057f \u0576\u0577\u0561\u0576",
  "cruzeiro sign":
    "\u0576\u0561\u057e\u0561\u0580\u056f\u0578\u0582\u0569\u0575\u0561\u0576 \u0576\u0577\u0561\u0576",
  "french franc sign":
    "\u0586\u0580\u0561\u0576\u057d\u056b\u0561\u056f\u0561\u0576 \u0586\u0580\u0561\u0576\u056f\u056b \u0576\u0577\u0561\u0576",
  "lira sign": "\u056c\u056b\u0580\u056b \u0576\u0577\u0561\u0576",
  "mill sign":
    "\u057b\u0580\u0561\u0572\u0561\u0581\u056b \u0576\u0577\u0561\u0576",
  "naira sign":
    "\u0576\u0561\u056b\u0580\u0561\u0575\u056b \u0576\u0577\u0561\u0576",
  "peseta sign":
    "\u057a\u0565\u057d\u0565\u057f\u0561\u0575\u056b \u0576\u0577\u0561\u0576",
  "rupee sign": "\u057c\u0578\u0582\u0583\u056b\u056b \u0576\u0577\u0561\u0576",
  "won sign":
    "\u0577\u0561\u0570\u0565\u056c\u0578\u0582 \u0576\u0577\u0561\u0576\u0568",
  "new sheqel sign":
    "\u0576\u0578\u0580 \u0577\u0565\u056f\u0565\u056c \u0576\u0577\u0561\u0576",
  "dong sign": "\u0564\u0578\u0576\u0563\u056b \u0576\u0577\u0561\u0576",
  "kip sign": "\u056f\u056b\u057a \u0576\u0577\u0561\u0576",
  "tugrik sign":
    "\u057f\u0578\u0582\u0563\u0580\u056b\u056f\u056b \u0576\u0577\u0561\u0576",
  "drachma sign":
    "\u0564\u0580\u0561\u0574\u0561\u056d\u0574\u0561\u0575\u056b \u0576\u0577\u0561\u0576",
  "german penny symbol":
    "\u0563\u0565\u0580\u0574\u0561\u0576\u0561\u056f\u0561\u0576 \u057a\u0565\u0576\u056b\u0575\u056b \u056d\u0578\u0580\u0570\u0580\u0564\u0561\u0576\u056b\u0577",
  "peso sign": "\u057a\u0565\u057d\u0578\u0575\u056b \u0576\u0577\u0561\u0576",
  "guarani sign":
    "\u0563\u0578\u0582\u0561\u0580\u0561\u0576\u056b \u0576\u0577\u0561\u0576",
  "austral sign":
    "\u0561\u057e\u057d\u057f\u0580\u0561\u056c\u056b \u0576\u0577\u0561\u0576",
  "hryvnia sign":
    "\u0563\u0580\u056b\u057e\u0576\u0561\u0575\u056b \u0576\u0577\u0561\u0576",
  "cedi sign": "\u0584\u0565\u0564\u056b \u0576\u0577\u0561\u0576",
  "livre tournois sign":
    "\u056c\u056b\u057e\u0580\u0565 \u0569\u0578\u0582\u0580\u0576\u0578\u056b\u057d \u0576\u0577\u0561\u0576",
  "spesmilo sign":
    "\u057d\u057a\u0565\u057d\u0574\u056b\u056c\u0578 \u0576\u0577\u0561\u0576",
  "tenge sign": "\u057f\u0565\u0576\u0563\u0565 \u0576\u0577\u0561\u0576",
  "indian rupee sign":
    "\u0570\u0576\u0564\u056f\u0561\u056f\u0561\u0576 \u057c\u0578\u0582\u0583\u056b \u0576\u0577\u0561\u0576",
  "turkish lira sign":
    "\u0569\u0578\u0582\u0580\u0584\u0561\u056f\u0561\u0576 \u056c\u056b\u0580\u0561\u0575\u056b \u0576\u0577\u0561\u0576",
  "nordic mark sign":
    "\u0570\u0575\u0578\u0582\u057d\u056b\u057d\u0561\u0575\u056b\u0576 \u0576\u0577\u0561\u0576\u056b \u0576\u0577\u0561\u0576",
  "manat sign": "\u0574\u0561\u0576\u0561\u0569\u056b \u0576\u0577\u0561\u0576",
  "ruble sign":
    "\u057c\u0578\u0582\u0562\u056c\u0578\u0582 \u0576\u0577\u0561\u0576",
  "yen character": "\u056b\u0565\u0576\u056b \u0576\u0577\u0561\u0576",
  "yuan character":
    "\u0575\u0578\u0582\u0561\u0576\u056b \u0576\u0577\u0561\u0576",
  "yuan character, in hong kong and taiwan":
    "\u0575\u0578\u0582\u0561\u0576\u056b \u0576\u0577\u0561\u0576 \u0570\u0578\u0576\u0563\u056f\u0578\u0576\u0563\u0578\u0582\u0574 \u0587 \u0569\u0561\u0575\u057e\u0561\u0576\u0578\u0582\u0574",
  "yen/yuan character variant one":
    "\u0575\u0565\u0576\u056b/\u0575\u0578\u0582\u0561\u0576\u056b \u0576\u0577\u0561\u0576 \u057f\u0561\u0580\u0562\u0565\u0580\u0561\u056f \u0561\u057c\u0561\u057b\u056b\u0576",
  "Loading emoticons...":
    "\u054d\u0574\u0561\u0575\u056c\u056b\u056f\u0576\u0565\u0580\u056b \u0562\u0565\u057c\u0576\u0578\u0582\u0574\u0568\u2024\u2024\u2024",
  "Could not load emoticons":
    "\u0549\u056f\u0561\u0580\u0578\u0572\u0561\u0581\u0561\u0576 \u0562\u0565\u057c\u0576\u057e\u0565\u056c \u057d\u0574\u0561\u0575\u056c\u056b\u056f\u0576\u0565\u0580\u0568",
  People: "\u0544\u0561\u0580\u0564\u056b\u0584",
  "Animals and Nature":
    "\u053f\u0565\u0576\u0564\u0561\u0576\u056b\u0576\u0565\u0580 \u0587 \u0532\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Food and Drink":
    "\u054d\u0576\u0578\u0582\u0576\u0564 \u0587 \u056d\u0574\u056b\u0579\u0584",
  Activity:
    "\u0533\u0578\u0580\u056e\u0578\u0582\u0576\u0565\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  "Travel and Places":
    "\u0543\u0561\u0576\u0561\u057a\u0561\u0580\u0570\u0578\u0580\u0564\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580 \u0587 \u057e\u0561\u0575\u0580\u0565\u0580",
  Objects: "\u0555\u0562\u0575\u0565\u056f\u057f\u0576\u0565\u0580",
  Flags: "\u0534\u0580\u0578\u0577\u0576\u0565\u0580",
  Characters: "\u0546\u056b\u0577\u0565\u0580",
  "Characters (no spaces)":
    "\u0546\u056b\u0577\u0565\u0580 (\u0562\u0561\u0581\u0561\u057f\u0576\u0565\u0580)",
  "{0} characters": "{0} \u0576\u056b\u0577\u0565\u0580",
  "Error: Form submit field collision.":
    "\u054d\u056d\u0561\u056c\u0589 \u0541\u0587\u0568 \u0570\u0561\u057d\u057f\u0561\u057f\u0565\u056c\u0578\u0582\u0581 \u0564\u0561\u0577\u057f\u056b \u0562\u0561\u056d\u0578\u0582\u0574:",
  "Error: No form element found.":
    "\u054d\u056d\u0561\u056c\u0589 \u0541\u0587\u056b \u0578\u0579 \u0574\u056b \u057f\u0561\u0580\u0580 \u0579\u056b \u0563\u057f\u0576\u057e\u0565\u056c:",
  Update: "\u0539\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056c",
  "Color swatch":
    "\u0533\u0578\u0582\u0575\u0576\u056b \u0583\u0578\u056d\u0561\u0576\u0561\u056f\u0578\u0582\u0574",
  Turquoise:
    "\u0553\u056b\u0580\u0578\u0582\u0566\u0561\u0563\u0578\u0582\u0575\u0576",
  Green: "\u053f\u0561\u0576\u0561\u0579",
  Blue: "\u053f\u0561\u057a\u0578\u0582\u0575\u057f",
  Purple:
    "\u0544\u0561\u0576\u0578\u0582\u0577\u0561\u056f\u0561\u0563\u0578\u0582\u0575\u0576",
  "Navy Blue":
    "\u0544\u0578\u0582\u0563 \u056f\u0561\u057a\u0578\u0582\u0575\u057f",
  "Dark Turquoise":
    "\u0544\u0578\u0582\u0563 \u0583\u056b\u0580\u0578\u0582\u0566\u0561\u0563\u0578\u0582\u0575\u0576",
  "Dark Green": "\u0544\u0578\u0582\u0563 \u056f\u0561\u0576\u0561\u0579",
  "Medium Blue":
    "\u0544\u056b\u057b\u056b\u0576 \u056f\u0561\u057a\u0578\u0582\u0575\u057f",
  "Medium Purple":
    "\u0544\u056b\u057b\u056b\u0576 \u0574\u0561\u0576\u0578\u0582\u0577\u0561\u056f\u0561\u0563\u0578\u0582\u0575\u0576",
  "Midnight Blue":
    "\u053f\u0565\u057d\u0563\u056b\u0577\u0565\u0580\u0561\u0575\u056b\u0576 \u056f\u0561\u057a\u0578\u0582\u0575\u057f",
  Yellow: "\u0534\u0565\u0572\u056b\u0576",
  Orange: "\u0546\u0561\u0580\u0576\u057b\u0561\u0563\u0578\u0582\u0575\u0576",
  Red: "\u053f\u0561\u0580\u0574\u056b\u0580",
  "Light Gray":
    "\u0532\u0561\u0581 \u0574\u0578\u056d\u0580\u0561\u0563\u0578\u0582\u0575\u0576",
  Gray: "\u0544\u0578\u056d\u0580\u0561\u0563\u0578\u0582\u0575\u0576",
  "Dark Yellow": "\u0544\u0578\u0582\u0563 \u0564\u0565\u0572\u056b\u0576",
  "Dark Orange":
    "\u0544\u0578\u0582\u0563 \u0576\u0561\u0580\u0576\u057b\u0561\u0563\u0578\u0582\u0575\u0576",
  "Dark Red": "\u0544\u0578\u0582\u0563 \u056f\u0561\u0580\u0574\u056b\u0580",
  "Medium Gray":
    "\u0544\u056b\u057b\u056b\u0576 \u0574\u0578\u056d\u0580\u0561\u0563\u0578\u0582\u0575\u0576",
  "Dark Gray":
    "\u0544\u0578\u0582\u0563 \u0574\u0578\u056d\u0580\u0561\u0563\u0578\u0582\u0575\u0576",
  "Light Green": "\u0532\u0561\u0581 \u056f\u0561\u0576\u0561\u0579",
  "Light Yellow": "\u0532\u0561\u0581 \u0564\u0565\u0572\u056b\u0576",
  "Light Red": "\u0532\u0561\u0581 \u056f\u0561\u0580\u0574\u056b\u0580",
  "Light Purple":
    "\u0532\u0561\u0581 \u0574\u0561\u0576\u0578\u0582\u0577\u0561\u056f\u0561\u0563\u0578\u0582\u0575\u0576",
  "Light Blue": "\u0532\u0561\u0581 \u056f\u0561\u057a\u0578\u0582\u0575\u057f",
  "Dark Purple":
    "\u0544\u0578\u0582\u0563 \u0574\u0561\u0576\u0578\u0582\u0577\u0561\u056f\u0561\u0563\u0578\u0582\u0575\u0576",
  "Dark Blue":
    "\u0544\u0578\u0582\u0563 \u056f\u0561\u057a\u0578\u0582\u0575\u057f",
  Black: "\u054d\u0587",
  White: "\u054d\u057a\u056b\u057f\u0561\u056f",
  "Switch to or from fullscreen mode":
    "\u0531\u0576\u0581\u0565\u0584 \u0561\u0574\u0562\u0578\u0572\u057b \u0567\u056f\u0580\u0561\u0576\u056b\u0576 \u057c\u0565\u056a\u056b\u0574\u056b\u0581 \u056f\u0561\u0574 \u0561\u0574\u0562\u0578\u0572\u057b \u057c\u0565\u056a\u056b\u0574\u056b\u0581",
  "Open help dialog":
    "\u0532\u0561\u0581\u0565\u056c \u0585\u0563\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0565\u0580\u056f\u056d\u0578\u057d\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
  history: "\u054a\u0561\u057f\u0574\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  styles: "\u0578\u0573\u0565\u0580\u0568",
  formatting: "\u0579\u0561\u0583\u0561\u0576\u0577\u0578\u0582\u0574",
  alignment:
    "\u0570\u0561\u057e\u0561\u057d\u0561\u0580\u0565\u0581\u0578\u0582\u0574",
  indentation: "\u056d\u0561\u0575\u0569\u0578\u0581",
  "permanent pen":
    "\u0574\u0577\u057f\u0561\u056f\u0561\u0576 \u0563\u0580\u056b\u0579",
  comments:
    "\u0574\u0565\u056f\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
  "Format Painter":
    "\u0541\u0587\u0561\u0579\u0561\u0583\u056b \u0576\u056f\u0561\u0580\u056b\u0579",
  "Insert/edit iframe":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u0584/\u056d\u0574\u0562\u0561\u0563\u0580\u0565\u0584 iframe- \u0568",
  Capitalization: "\u0544\u0565\u056e\u0561\u057f\u0561\u057c",
  lowercase: "\u0553\u0578\u0584\u0580\u0561\u057f\u0561\u057c",
  UPPERCASE: "\u0544\u0535\u053e\u0531\u054f\u0531\u054c",
  "Title Case":
    "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580 \u0533\u0578\u0580\u056e",
  "Permanent Pen Properties":
    "\u0544\u0577\u057f\u0561\u056f\u0561\u0576 \u0563\u0580\u056b\u0579\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  "Permanent pen properties...":
    "\u0544\u0577\u057f\u0561\u056f\u0561\u0576 \u0563\u0580\u056b\u0579\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u2024\u2024\u2024",
  Font: "\u054f\u0561\u057c\u0561\u057f\u0565\u057d\u0561\u056f",
  Size: "\u0549\u0561\u0583\u057d",
  "More...": "\u0531\u057e\u0565\u056c\u056b\u0576\u2024\u2024\u2024",
  "Spellcheck Language":
    "\u0548\u0582\u0572\u0572\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u057d\u057f\u0578\u0582\u0563\u0574\u0561\u0576 \u056c\u0565\u0566\u0578\u0582",
  "Select...": "\u0538\u0576\u057f\u0580\u0565\u056c\u2024\u2024\u2024",
  Preferences:
    "\u0546\u0561\u056d\u0561\u057a\u0561\u057f\u057e\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
  Yes: "\u0531\u0575\u0578",
  No: "\u0548\u0579",
  "Keyboard Navigation":
    "\u054d\u057f\u0565\u0572\u0576\u0561\u0577\u0561\u0580\u056b \u0546\u0561\u057e\u056b\u0563\u0561\u0581\u056b\u0561",
  Version: "\u054f\u0561\u0580\u0562\u0565\u0580\u0561\u056f",
  Anchor: "\u053d\u0561\u0580\u056b\u057d\u056d",
  "Special character":
    "\u0540\u0561\u057f\u0578\u0582\u056f \u057d\u056b\u0574\u057e\u0578\u056c\u0576\u0565\u0580",
  "Code sample":
    "\u053f\u0578\u0564\u056b \u0585\u0580\u056b\u0576\u0561\u056f",
  Color: "\u0533\u0578\u0582\u0575\u0576",
  Emoticons: "\u054d\u0574\u0561\u0575\u056c\u056b\u056f\u0576\u0565\u0580",
  "Document properties":
    "\u0553\u0561\u057d\u057f\u0561\u0569\u0572\u0569\u056b \u0570\u0561\u057f\u056f\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
  Image: "\u0546\u056f\u0561\u0580",
  "Insert link":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0570\u0572\u0578\u0582\u0574",
  Target: "\u0539\u056b\u0580\u0561\u056d",
  Link: "\u0540\u0572\u0578\u0582\u0574",
  Poster: "\u054a\u0561\u057d\u057f\u0561\u057c",
  Media: "\u0544\u0565\u0564\u056b\u0561",
  Print: "\u054f\u057a\u0565\u056c",
  Prev: "\u0546\u0561\u056d\u0578\u0580\u0564",
  "Find and replace":
    "\u0553\u0576\u057f\u0580\u0565\u056c \u0587 \u0583\u0578\u056d\u0561\u0580\u056b\u0576\u0565\u056c",
  "Whole words":
    "\u0532\u0561\u057c\u0565\u0580\u0568 \u0561\u0574\u0562\u0578\u0572\u057b\u0578\u0582\u0569\u0575\u0561\u0574\u0562",
  Spellcheck:
    "\u0548\u0582\u0572\u0572\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  Caption: "\u054e\u0565\u0580\u0576\u0561\u0563\u056b\u0580",
  "Insert template":
    "\u054f\u0565\u0572\u0561\u0564\u0580\u0565\u056c \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
});
